import styled from "styled-components";
//background: radial-gradient(circle, rgba(83,64,240,1) 52%, rgba(83,64,240,0.8158613787311799) 100%);
//background-attachment:fixed;
export const BackgroundContainer = styled("section")`
background: #deb4b1;
background-attachment: fixed;
  min-height:100vh;


  
  overflow-x: hidden;


`;

